/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState } from 'react';

import { useDataModel } from '@thd-nucleus/data-sources';
import {
  PlccHDHomeDataModel
} from '../contentful/dataModel/dataModel';

const ContentfulContext = createContext();

export const useContentfulContext = () => {
  return useContext(ContentfulContext);
};

export const ContentfulProvider = ({ children, componentId, componentClass = 'PlccInlineComponent' }) => {
  const [state, setState] = useState({});

  const { data: plccData, error: plccDataError = null, loading } = useDataModel('component', {
    variables: { id: componentId, componentClass },
    dataModel: PlccHDHomeDataModel,
    skip: !componentId
  });

  const updateState = (newState) => {
    setState((prevState) => ({ ...prevState, ...newState }));
  };

  const fallbackData = {
    component: {
      creditCard: {
        cardImage: { url: '', alt: 'Credit Card' },
        fields: { creditCardName: 'PLNP_HOMEDEPOT' }
      },
      plccDrawerContent: {},
      plccPromoInfo: {
        everydayDfp: '',
        applianceDfp: '',
        tieredDfp: '',
        twelveMonthsSpecialDfp: '',
        tieredApplianceDfp: '',
        crcDfp: '',
        appliancePromoDates: [],
        tieredPromoDates: [],
        twelveMonthSpecialPromoDates: [],
        tieredApplianceDates: []
      }
    }
  };

  if (loading) {
    return null;
  }

  if (plccDataError || !plccData) {
    if (plccDataError) {
      // eslint-disable-next-line no-console
      console.warn('error fetching contentful data or component not found, using fallback', plccDataError);
    }

    return (
      <ContentfulContext.Provider
        value={{
          state,
          updateState,
          plccData: fallbackData,
          plccDataError,
        }}
      >
        {children}
      </ContentfulContext.Provider>
    );
  }

  return (
    <ContentfulContext.Provider
      value={{
        state,
        updateState,
        plccData: plccData,
        plccDataError: null,
      }}
    >
      {children}
    </ContentfulContext.Provider>
  );
};
